<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  created() {
    const IS_PRDO = window.location.host.startsWith('qianchuan.jinritemai.com')
    window.Slardar('config', {
      sampleRate: 1, // 采样率 (0, 1]
      bid: IS_PRDO ? 'ecom_marketing_fe' : 'boe_ecom_marketing_fe', // 业务标识
      pid: window.location.pathname, // 页面标识
      ignoreAjax: ['mcs.snssdk.com', 'api.growingio.com'], // 无需监控的ajax url规则集
      ignoreStatic: [], // 无需监控的静态资源 url规则集
      hookFetch: true, // 是否劫持fetch
      enableSizeStats: true, // 是否强制计算fetch的响应大小
      // domain: 'i.snssdk.com', // 注意上报域名如果使用默认域名 i.snssdk.com, 可不填写。 如果是国际化项目，请改成 mon-va.byteoversea.com
      context: {
        gfenv: window.gfdatav1 || 'NOT_FINDED',
      }, // 自定义维度
    })
  }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
body {
  margin: 0;
}
</style>
